"use client";
import { useMemo as o, useState as n, useEffect as u } from "react";
import { fileMatchesAccept as f } from "../../../utils/utils.mjs";
import { useFileInput as p } from "../../atoms/FileInput/useFileInput.mjs";
const a = "image/", M = (i, c = {}) => {
  const t = o(() => c.accept ?? [], [c.accept]), e = p(i, {
    ...c,
    accept: t
  }), [l, r] = n(null);
  return u(() => {
    if (!e.file || t.length > 0 && !f(e.file, t) || !e.file.type.startsWith(a)) {
      r(null);
      return;
    }
    const s = URL.createObjectURL(e.file);
    return r(s), () => {
      URL.revokeObjectURL(s);
    };
  }, [e.file, t]), { ...e, previewUrl: l };
};
export {
  M as useImageFileInput
};
